import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { compose } from 'recompose';
import withAuthorization from '../auth/withAuthorization';

import { fetchGame, fetchStatsForGame } from "../../actions/index";

import '../../global.css';
import '../yourpage/HomePage.css';
import {GameStats} from "../yourpage/GameEntryListItem";

/**
 * A listing of the game plays for a hunt
 */
class HuntActivity extends Component  {
   // helper to grab the game id
   id() {
      return this.props.match.params.id;
   }

   // helper to grab the game
   game() {
      const { games } = this.props;
      return games[this.id()];
   }

   render() {
      const { stats, leaderboard, reviews, reports } = this.props;
      // game Id
      const id = this.id();
      // And still don't quite have all the data.
      if (!this.props.games) {
         fetchGame(id);
         return <div> Retrieving game data...</div>
      }
      const game = this.game();

      if (!stats) {
         fetchStatsForGame(game);
         return <div> Retrieving stat data...</div>
      }

      const aggregateStats = aggregateStatsReviewsReports(stats, leaderboard, reviews, reports);

      // Our link back
      const gameInfoPage = `/games/${id}`;

      return (
         <div className='editor'>

            <Link to={gameInfoPage} className="accent-link bottom-margin">
               Back To Game Info
            </Link>

            <div>
               <GameStats
                  game={game}
                  stats={aggregateStats}
                  onGameDetailsSelect={null}
                  showUser={false}
               />
            </div>
         </div>
      )
   }
}

export function aggregateStatsReviewsReports(stats, leaderboard, reviews, reports) {

   if (!stats) return null;

   const statsArray = stats.stats;
   const leaderboardArray = leaderboard.leaderboard
   const aggStats = [];

   const reviewsMap = reviews ? reviews.reviews : {};
   const reportsMap = reports ? reports.reports : {};

   const ids = { }

   if (leaderboardArray) {
      leaderboardArray.forEach( entry => {
            const userId = entry.userId;
            ids[userId] = {}
            const aggStat = { ...entry };

         // console.log("reviewsMap", reportsMap)
            const review = reviewsMap[userId];

            if (review) {
               aggStat.reviewText = review.text;
               aggStat.reviewRating = review.rating;
               aggStat.reviewDate = review.createdAt;
            }

            const report = reportsMap[userId];

            if (report) {
               aggStat.reportText = report.text;
               aggStat.reportDate = report.createdAt;
            }
            aggStats.push(aggStat);
         }
      )
   }

   statsArray.forEach( stat => {
      const userId = stat.userId;
      if (!ids[userId]) {
         // this stat was not on leaderboard, so add it.
         const aggStat = { ...stat };
         aggStat.name = aggStat.username

         const review = reviewsMap[userId];
         if (review) {
            aggStat.reviewText = review.text;
            aggStat.reviewRating = review.rating;
            aggStat.reviewDate = review.createdAt;
         }

         const report = reportsMap[userId];

         if (report) {
            aggStat.reportText = report.text;
            aggStat.reportDate = report.createdAt;
         }
         aggStats.push(aggStat);
      }
   });
   return aggStats;
}

const authCondition = (authUser) => !!authUser;

// boilerplate redux, tie in our app state to props
function mapStateToProps(state) {
   return {
      games: state.games,
      stats: state.gameStats,
      leaderboard: state.leaderboard,
      reviews: state.gameReviews,
      reports: state.gameReports,
   };
}

export default compose(
   withAuthorization(authCondition),
   connect(mapStateToProps, { fetchGame, fetchStatsForGame } ),
   withRouter
)(HuntActivity);



// WEBPACK FOOTER //
// ./src/components/huntedit/HuntActivity.js